// extracted by mini-css-extract-plugin
module.exports = {"ContentHeading_heading":"ContentHeading_ContentHeading_heading__5S_G3","ContentHeading_subtext":"ContentHeading_ContentHeading_subtext__D3oco"};